export default {
  "content": "<path d=\"M11 4H6v16h1v2H5a1 1 0 01-1-1V3a1 1 0 011-1h6v2zM11 22H9v-2h2v2zM15 22h-2v-2h2v2zM20 21a1 1 0 01-1 1h-2v-2h1v-4h2v5z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 8c3.094 0 6 2.042 6 5a1 1 0 01-1 1H11a1 1 0 01-1-1c0-2.958 2.906-5 6-5zm0 2c-1.87 0-3.231.913-3.759 2h7.518c-.528-1.087-1.889-2-3.759-2zM16 1a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};